import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { EmployeeDailyAbsentRepositoryImplService } from '../../../../infrastructure/repositories/Hr Management/attendance/att-employee-daily-absent-repository-impl.service';
import { AttEmployeeDailyAbsentModel, AttEmployeeDailyAbsentResponse } from '../../../../domain/models/Hr-Management/attendance/att-employee-daily-absent.model';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AttEmployeeDailyAbsentService extends BaseService<
   AttEmployeeDailyAbsentModel,
   AttEmployeeDailyAbsentResponse
> {
  constructor(private repo: EmployeeDailyAbsentRepositoryImplService) {
    super(repo);
  }

  getFiltered(filters: {
    companyId?: string;
    employeeId?: number;
    absentDate?: string;
    attAbsentId?: number;
    type?: number;
    status?: number;
    fromDate?: string;
    toDate?: string;
    page?: number;
    pageSize?: number;
  }) {
    return this.repo.getFiltered(filters);
  }


  /** att_review_01: a percentage set by hand on a 0% "no rule" row (Approve permission). */
  setManualPercent(id: number, percent: number): Observable<AttEmployeeDailyAbsentResponse> {
    return this.repo.setManualPercent(id, percent);
  }

decide(id: number, status: number, note: string, asAdjustment = false): Observable<AttEmployeeDailyAbsentResponse> {
    return this.repo.decide(id, status, note, asAdjustment);
  }

  decideMany(ids: number[], status: number, note: string, asAdjustment = false): Observable<any> {
    return this.repo.decideMany(ids, status, note, asAdjustment);
  }

}
